import { render } from "./PageHeader.vue?vue&type=template&id=d4ab4572&scoped=true"
const script = {}

import "./PageHeader.vue?vue&type=style&index=0&id=d4ab4572&scoped=true&lang=css"

import exportComponent from "/Users/yalemarc/Documents/yaleapps/simplify-photo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ab4572"]])

export default __exports__